module.exports = __webpack_public_path__ + "img/arrow-down-right-square-fill.68b88d39.svg";